export default class Controller {

    static get $inject() {
        return [
            '$state',
            'ApiAccountService',
            'LanguageService',
            'gettext',
            'toaster',
            '$scope'
        ];
    }

    constructor($state,
                ApiAccountService,
                LanguageService,
                gettext,
                toaster,
                $scope) {

        this._$state = $state;
        this.gettext = gettext;
        this.LanguageService = LanguageService;
        this._ApiAccountService = ApiAccountService;
        this.toaster = toaster;
        this.$scope = $scope;
        this.placeholdersText = [gettext('First name'), gettext('Last name')]

        this._ApiAccountService.getUserDetails().then(() => {
            this.$scope.item = {firstName: this.getUserFirstName(), lastName: this.getUserLastName()};
        })

    }

    submit() {
        this._ApiAccountService.setUserDetails(this.$scope.item.firstName, this.$scope.item.lastName)
            .then(() => {
                this._ApiAccountService.getUserDetails();
                this.toaster.pop("success", "Success", "Profile saved");

            }).catch(err => {
            this.toaster.pop("error", "Error", "Something went wrong please try again later");
        });
    }


    getTranslatableText(text) {
        return this.LanguageService.getTranslatableText(text);
    }

    getUserFirstName() {
        return this._ApiAccountService.getUserFirstName();
    }

    getUserLastName() {
        return this._ApiAccountService.getUserLastName();
    }

}


















/** WEBPACK FOOTER **
 ** ./src/main/account/myProfile/controller.js
 **/